module.exports = __webpack_public_path__ + "img/login_bg.58362d88.jpg";